import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    HeaderClassName,
    pxArrayToRem,
    tileGridClassName,
    labelClassName,
} from '@archipro-design/aria';

export const FeaturedProjectsWrapper: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(210),
    [`& .${tileGridClassName}`]: {
        marginTop: pxToRem(90),
        [`& .${HeaderClassName}`]: {
            marginBottom: pxToRem(23),
            padding: pxArrayToRem([0, 0, 0, 18]),
            color: `${
                theme.siteVariables.colorScheme.default!.foreground
            } !important`,

            whiteSpace: 'unset',
            textAlign: 'left',
            letterSpacing: theme.siteVariables.letterSpacingMedium,
            fontWeight: 500,
            fontSize: pxToRem(22),
            lineHeight: theme.siteVariables.lineHeightDefault,

            // Bug applying maximumLines to header - remove once fixed
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',

            [theme.screen.min.tablet]: {
                fontSize: pxToRem(22),
                padding: pxArrayToRem([0, 0, 76, 0]),
                marginBottom: 0,
                whiteSpace: 'pre-line',
                letterSpacing: theme.siteVariables.letterSpacingSmall,
                marginLeft: pxToRem(924),
            },
        },
    },
    [theme.screen.tablet]: {
        marginTop: pxToRem(240),
    },
});

export const ViewMoreButton: StyleRule = () => ({
    textTransform: 'uppercase',
    marginTop: pxToRem(126),
    padding: pxArrayToRem([25.5, 25, 23, 24]),
});

export const LoadMoreButton: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    marginTop: pxToRem(128),
    padding: pxArrayToRem([24, 42.5]),
    textTransform: 'uppercase',
    outline: `1px solid ${siteVariables.colorScheme.default?.foreground}`,
    [`& .${labelClassName}`]: {
        letterSpacing: siteVariables.letterSpacingMedium,
        fontWeight: 500,
    },
    [screen.tablet]: {
        marginLeft: pxToRem(924),
    },
});
